import React, { Component } from 'react';

import ReduxConnect from 'Demora/redux-connect';

import socialHttp from '../../../../utils/socialHttp';

import { withRouter } from 'react-router-dom';

class BlockUser extends Component {
	blockUser = () => {
		const props = this.props;

		socialHttp(
			'delete',
			'/data/relationships/' + props.obj + '/block/' + props.user
		)
			.then((data) => {
				props.history.push('/home');
			})
			.catch((e) => {
				throw e;
			});
	};

	render() {
		const props = this.props;

		return (
			<div>
				<div onClick={this.blockUser}>
					{props.buttonText ? (
						props.buttonText
					) : (
						<span>
							<i className='fa fa-ban' aria-hidden='true'></i>&nbsp;Block{' '}
							{props.users[props.user].first_name}
						</span>
					)}
				</div>
			</div>
		);
	}
}

export default withRouter(
	ReduxConnect(BlockUser, {
		users: 'users',
	})
);
